// Module
var code = `<div class="modal-header"><h3 class="modal-title">Confirmation</h3></div><div class="modal-body" class=".pre-line-white-space">{{vm.message}}</div><div class="modal-footer"><button class="btn" ng-click="vm.ok()">{{vm.confirmButtonText}}</button> <button class="btn btn-danger" ng-click="vm.cancel()">{{vm.cancelButtonText}}</button></div>`;
// Exports
export default code;